import { Component, OnInit } from '@angular/core';
import { InspectionService } from '../../service/inspection/inspection.service';
import { Inspection } from '../../class/inspection';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-inspections',
  templateUrl: './inspections.component.html',
  styleUrls: ['./inspections.component.scss']
})
export class InspectionsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public inspections: Inspection[];
    public selectInspection: Inspection;
    public inspectionID: Number = 0;
    public modNew = false;
    public modView = false;
    public openInspection = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public filters: {key: string, value: string}[];
    public first = 0;

    public employeePositionToLoadMaintenanceAssistant: string;
    public employeePositionToLoadManager: string;

    public station_id_filter: AbstractControl;
    public maintenance_assistant_id_filter: AbstractControl;
    public service_manager_id_filter: AbstractControl;

    public apiUrl = config.API_ROOT;
    public modExportDialog: boolean;

    public form4: FormGroup;
    public f4_date_start: AbstractControl;
    public f4_date_end: AbstractControl;

    public es: any;

    constructor(
        fb: FormBuilder,
        public inspectionService: InspectionService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        private notificationsService: NotificationsService,
        public translate: TranslateService) {

            this.es = calendarES();

          this.employeePositionToLoadMaintenanceAssistant = '3';
          this.employeePositionToLoadManager = '2';

          this.form3 = fb.group({
            'station_id_filter': [''],
            'maintenance_assistant_id_filter': [''],
            'service_manager_id_filter': [''],
          });
          this.station_id_filter = this.form3.controls['station_id_filter'];
          this.maintenance_assistant_id_filter = this.form3.controls['maintenance_assistant_id_filter'];
          this.service_manager_id_filter = this.form3.controls['service_manager_id_filter'];

            this.form4 = fb.group({
                'f4_date_start': ['', [Validators.required]],
                'f4_date_end': ['', [Validators.required]],
            });
            this.f4_date_start = this.form4.controls['f4_date_start'];
            this.f4_date_end = this.form4.controls['f4_date_end'];

            this.modExportDialog = false;
        }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;
        //this.getInspections();
    }

    public loadInspectionsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';

        this.filter();
    }

    public getInspections() {
        this.inspectionService.getInspection(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.inspections = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getInspectionId(id) {
        this.inspectionService.infoInspection(id).toPromise().then(
            response => {
                this.selectInspection = response.json().data[0];
            },
            error => {
                let msg = '';
                this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                        JSON.parse(error._body).errors.forEach(element => {
                            if (element.source) {
                                if (element.source.pointer) {
                                    this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                        msg = msg + res3 + ', ';
                                    });
                                }
                            }
                        });
                        this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                        // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    });
                });
            }
        );
    }

    public newInspection() {
        this.modNew = !this.modNew;
        this.selectInspection = null;
    }

    public savedInspection(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectInspection = null;
        this.modNew = false;
        this.getInspections();
    }

    public cancelInspection (res) {
        this.selectInspection = null;
        this.modNew = false;
        this.modView = false;
        this.getInspections();
    }

    public edit(inspection: Inspection) {
        this.modNew = true;
        this.selectInspection = inspection;
        //this.getInspections();
    }

    public reloadInspection(id) {
        this.getInspectionId(id);
    }

    public view(inspection: Inspection) {
        this.openInspection = true;
        this.selectInspection = inspection;
        this.inspectionID = inspection.id;
        this.modView = true;
    }

    public deleteDialog(inspection: Inspection) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(inspection);
            }
        });
    }

    public delete(inspection: Inspection) {
        this.inspectionService.deleteInspection(inspection.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getInspections();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeInspection(inspection: Inspection) {
        this.putInspection(inspection);
    }

    public hasPermission(permission) {
      return this.hasPermissionService.hasPermission(permission);
    }

    public putInspection(values: Inspection) {
        const param = {
            // 'activated': values.activated
        };
        if (values) {
            const promise = this.inspectionService.updateInspection(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }

    public filter (values?, pageRefresh?) {
      if (pageRefresh) {
        this.page = 1;
        this.first = 0;
        this.per_page = 10;
      }
      if (values) {
        this.filters = [];
        if (values.station_id_filter) {
          this.filters.push({'key': 'station_id-in', 'value': values.station_id_filter.id});
        }
        if (values.maintenance_assistant_id_filter) {
          this.filters.push({'key': 'maintenance_assistant_id-in', 'value': values.maintenance_assistant_id_filter.id});
        }
        if (values.service_manager_id_filter) {
          this.filters.push({'key': 'service_manager_id-in', 'value': values.service_manager_id_filter.id});
        }
      }
      this.getInspections();
    }

    public showExportDialog() {
        console.log('hola');
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/inspections/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        window.open(url, '_blank');
    }

    printInspection(inspection) {
        window.open(this.apiUrl + '/inspections/' + inspection.id + '/excel?token=' + localStorage.getItem('token'), '_blank');
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspections/inspections.component.ts